var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@xstyled/styled-components';
import { Popper } from 'react-popper';
import { useClickOutside } from '../Modal/hooks/useClickOutside';
import Portal from '../../Elements/Portal';
var PopoverWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 5;\n"], ["\n  z-index: 5;\n"])));
var Popover = function (_a) {
    var placement = _a.placement, wrapper = _a.wrapper, children = _a.children, onClose = _a.onClose, parentRef = _a.parentRef;
    var popperRef = useClickOutside({ onClose: onClose, parentRef: parentRef });
    var Wrapper = wrapper || PopoverWrapper;
    return (_jsx(Portal, { children: _jsx("div", { ref: popperRef, children: _jsx(Popper, { innerRef: popperRef, referenceElement: parentRef.current, placement: placement, children: function (_a) {
                    var ref = _a.ref, style = _a.style;
                    return (_jsx(Wrapper, { ref: ref, style: style, children: children }));
                } }) }) }));
};
export default Popover;
var templateObject_1;
